import { Box, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Avatar } from '@zignaly-open/ui';
import { useActiveExchange } from 'apis/user/use';
import React from 'react';
import { Link } from 'react-router-dom';
import { AccountName } from '../AccountMenu/styles';

export const ExchangeAccount = () => {
  const activeExchange = useActiveExchange();

  return (
    <Box display='flex' gap={1} justifyContent='center'>
      <Avatar size={'medium'} image={activeExchange?.image} />
      <AccountName variant={'body1'} color={'neutral100'}>
        {activeExchange?.internalName}
      </AccountName>
    </Box>
  );
};

export const DrawerMenuItem: React.FC<{
  closeDrawer: () => void;
  id: string;
  path: string;
  label: string;
}> = ({ closeDrawer, id, path, label }) => (
  <ListItem disablePadding onClick={closeDrawer} sx={{ pl: 4 }}>
    <ListItemButton id={id} to={path} component={Link}>
      <ListItemText primary={label} />
    </ListItemButton>
  </ListItem>
);
